export default __webpack_public_path__ + "static/media/filter.e9406a62.svg";